/**
 * @file components/audit-tasks/phases/PhaseClosing.tsx
 * @description 階段 6：結案（占位）。
 *
 * 報告核准後移交給驗證決定流程；本次僅提示後續流向。
 */

import { Alert, Card, Space, Typography } from 'antd';
import { Link } from '@tanstack/react-router';
import { CheckSquare, ExternalLink } from 'lucide-react';
import type { AuditTaskDetail } from '@zhcb/shared';

interface Props {
  task: AuditTaskDetail;
}

export function PhaseClosing({ task }: Props) {
  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      <Card
        size="small"
        title={
          <Space size={6}>
            <CheckSquare size={14} />
            <span>結案與移交</span>
          </Space>
        }
      >
        <Alert
          type="info"
          showIcon
          message="後續流程"
          description={
            <Space direction="vertical" size={4}>
              <Typography.Text style={{ fontSize: 13 }}>
                稽核報告管理員核准後，案件 {task.caseCode ?? `#${task.caseId}`}{' '}
                將自動進入驗證決定流程。
              </Typography.Text>
              <Link to="/decisions" style={{ fontSize: 12 }}>
                <Space size={4}>
                  驗證決定管理 <ExternalLink size={12} />
                </Space>
              </Link>
            </Space>
          }
        />
      </Card>
    </Space>
  );
}
